import "react-bootstrap-table2-toolkit/dist/react-bootstrap-table2-toolkit.min.css";
import ToolkitProvider, { Search } from "react-bootstrap-table2-toolkit";
import BootstrapTable from "react-bootstrap-table-next";
import Swal from "sweetalert2/dist/sweetalert2.js";
import { ToastContainer, toast } from "react-toastify";
import "sweetalert2/src/sweetalert2.scss";
import Lightbox from "react-image-lightbox";
import moment from "moment";
//import filter modal
import FilterModal from "components/Modal/FilterModal";
import {
    getRequest,
    postRequest,
    deleteRequest,
    putRequest,
    postRequestForm,
    deleteConfirmationWords,
} from "components/Common/Utils";

import paginationFactory, {
    PaginationProvider,
    PaginationListStandalone,
    SizePerPageDropdownStandalone,
} from "react-bootstrap-table2-paginator";
import axios from "axios";

import {
    Row,
    Col,
    Card,
    CardBody,
    CardTitle,
    Spinner,
    Badge,
    UncontrolledTooltip,
    Modal,
    Button,
} from "reactstrap";
import React, { useState, useEffect } from "react";
import { Link, NavLink } from "react-router-dom";
import ReactPaginate from "react-paginate";
import { change } from "redux-form";
import { id } from "date-fns/locale";
import ReactTooltip from "react-tooltip";

const filterObj = {
    first_name: "",
    last_name: "",
    gender: "",
    email: "",
    phone: "",
    country: "",
    nationality: "",
    bookingCode: "",
    bookingDate: "",
    agentEmail: "",
};

const InquiryList = (props) => {
    const [modal_center, setmodal_center] = useState(false);
    const [Categorydata, setCategorydata] = useState([]);
    const [loader, setLoader] = useState(false);
    const [searchText, setSearchText] = useState("");
    const [value, setValue] = React.useState(10);
    const [sort, setsort] = React.useState("");
    const [sortOrder, setsortOrder] = React.useState("desc");
    const [currentFPage, setCurrentFPage] = useState(1);
    const [currentPage, setCurrentPage] = useState(1);
    const [totalPage, setTotalPage] = useState(0);
    const [sizePerPageOrg, setSizePerPage] = useState(10);
    const [image, setImage] = React.useState("");
    const [openLightbox, setOpenLightBox] = React.useState(false);
    const [sizeList, setSizeList] = useState([]);
    const [model, setModel] = useState(false);
    const [canCreate, setCanCreate] = useState(true);
    const [canEdit, setCanEdit] = useState(true);
    const [canDelete, setCanDelete] = useState(true);
    const [canExport, setCanExport] = useState(true);
    const [filter, setFilter] = useState({ ...filterObj });
    const [loader2, setLoader2] = useState(false);

    useEffect(() => {
        fetchTransactionsList();
    }, [currentPage]);

    useEffect(() => {
        fetchTransactionsList();
    }, [sort, sortOrder]);

    const GetValueOnChange = async (isActive, item) => {
        const payload = {
            id: item?._id,
            question: item?.question,
            answer: item?.answer,
            isPublished: isActive == true ? false : true,
            isDeleted: item?.isDeleted,
        }
        const res = await postRequest("support/quick-question/update", payload);
        if (res.status) {
            toast.success(res.message);
            fetchTransactionsList();
        } else {
            toast.error("Something went wrong");
            setLoader(false);
        }
    };
    const closeModal = () => {
        setModel(false);
    };

    const toggleModel = () => {
        console.log("toggleModel", model);
        setModel(!model);
    };

    const handleTableChange = (type, { page, sizePerPage, searchText }) => {
        if (type === "pagination") {
            if (page != currentPage) {
                setCurrentPage(page);
                console.log("page", page);
            }
        }

        console.log("type", type);

        if (type === "search") {
            console.log("searchText", searchText);
        }
    };

    const showLightBox = (image) => {
        setImage(image);
        setOpenLightBox(true);
    };

    function SNoFormatter(cellContent, row, i) {
        return <>{i + 1}</>;
    }

    const columns = [
        {
            text: "S.NO",
            formatter: SNoFormatter,
            sort: false,
        },
        // {
        //     dataField: "agentId",
        //     text: "Agent ID",
        //     sort: false,
        // },
        {
            text: "User Info",
            sort: false,
            formatter: (cell, row) => (
                <Link to={{
                    pathname: `/userdetails/${row?.userDetail?._id}`,
                }} className="d-flex align-items-center justify-content-start text-start" style={{ gap: '10px' }}>
                    <span><img src={row?.userDetail?.photo} width='40px' /></span>
                    <div style={{ color: '#696464' }}>
                        <span>{row?.userDetail?.name}</span><br />
                        <span>{row?.userDetail?.email}</span>
                    </div>
                </Link>
            ),
        },
        {
            text: "Manufacturer Info",
            sort: false,
            formatter: (cell, row) => (
                <div className="d-flex gap-2 align-items-center">
                    <Link to={`/manufacturers-details/${row?.manufacturerDetail?._id}`}>
                        <div style={{ width: '50px' }}><img src={row?.manufacturerDetail?.logo} width="50px" /></div>
                    </Link>
                    <div className="flex-product text-start">
                        <Link to={`/manufacturers-details/${row?.manufacturerDetail?._id}`} className="mb-0">{row?.manufacturerDetail?.companyName}</Link>
                        {/* <p className="mb-0">{row?.manufacturerDetail?.mobile}, </p> */}
                        <p className="mb-0">{row?.manufacturerDetail?.email}</p>
                    </div>
                </div>
            ),
        },
        {
            text: "Product Inquiry",
            sort: false,
            formatter: (cell, row) => (
                <div className="d-flex gap-2 align-items-center">
                    <Link to={`/product-details/${row?.productDetails?._id}`}>
                        <div style={{ width: '50px' }}><img src={row?.productDetails?.images?.[0]} width="50px" /></div>
                    </Link>
                    <div className="flex-product text-start">
                        <Link to={`/product-details/${row?.productDetails?._id}`} className="mb-0">{row?.manufacturerDetail?.name}</Link>
                        {/* <p className="mb-0">{row?.manufacturerDetail?.mobile}, </p> */}
                        <p className="mb-0">Quantity : {row?.quantity} {row?.unit && '/'} {row?.unit}</p>
                    </div>
                </div>
            ),
        },

        {
            text: "Inquiry Message",
            sort: false,
            dataField: 'message',
        },
        {
            text: "Date of Inquiry",
            sort: false,
            dataField: 'created',
            formatter: (cell, row) => (
                <>{moment(row?.createdAt).format("DD-MM-YYYY hh:mm A")} </>
            ),
        },
        {
            text: (
                <div className="w-34"> Status
                    <i
                        data-tip
                        data-for="title-tooltip"
                        className="fa fa-info-circle"
                        style={{ marginLeft: '5px', cursor: 'pointer' }}
                    ></i>

                    <ReactTooltip id="title-tooltip" place="bottom">
                    If open, users can send inquiries to the manufacturer. If closed, inquiries to the manufacturer will be disabled.
                    </ReactTooltip>
                </div>
            ),
            sort: false,
            formatter: statusFormatter,
        },

        // {
        //     dataField: "order",
        //     text: "Order Details",
        //     sort: false,
        // },

        {
            dataField: "actions",
            text: "Action",
            formatter: iconFormatter,
            sort: false,
        },
    ];
    const handleChange = (event) => {
        console.log(event);
        setSizePerPage(event.target.value);
        if (currentPage != 1) {
            setCurrentPage(1);
        } else {
            fetchTransactionsList(event.target.value);
        }
    };
    const handlesorting = (event) => {
        setsort(event.target.value);
    };
    const handlesortOrder = (event) => {
        setsortOrder(event.target.value);
    };

    const handleReload = () => {
        setSearchText("");
    };

    function iconFormatter(cellContent, row) {
        return (
            <div className="d-flex gap-2">
                <button type="button" className=" btn btn-primary">
                    <Link
                        to={{
                            pathname: `/InuiryReplyViewMode/${row?._id}`,
                            state: { row },
                        }}
                    >
                        <i className="fal fa-eye fs-5 text-light"></i>
                    </Link>
                </button>
            </div>
        );
    }

    function statusFormatter(cellContent, row) {
        console.log({ row });
        const isActive = row.status;
        return (
            <button
                className={`btn ${isActive === 'open' ? 'btn-active' : 'btn-deactive'}`}
                type="button"
                disabled={isActive === 'closed'}
                onClick={() => GetValueOnChange(isActive, row._id)}
            >
                {isActive === 'open' ? 'Open' : 'Close'}
            </button>
        );
    }


    // const limit = 10;
    const fetchTransactionsList = async (limit = null) => {
        console.log(currentPage);
        setLoader(true);
        const payload = {
            limit: limit ? limit : sizePerPageOrg,
            page: currentPage,
            search: searchText,
            sortOrder: sortOrder,
            filterArgs: [
                {
                    type: "regex",
                    status: sort
                }
            ]
        };
        try {
            const response = await postRequest(`product/inquiry-list-admin`, payload);
            const data = response?.data;
            setTotalPage(data?.count);
            // setSizePerPage(sizePerPageOrg)
            setCurrentFPage(currentPage);
            setCategorydata(data?.list || []);
        } catch (error) {
            console.log("Failed to fetch data:", error);
        } finally {
            setLoader(false);
        }
    };

    return (
        <>
            <React.Fragment>
                <ToastContainer />
                <Row>
                    <div className="col-md-6">
                        <div className="page-title-box">
                            <h4>Inquiry Management</h4>
                            <ol className="breadcrumb m-0">
                                <li className="breadcrumb-item active">Inquiry Management</li>:{" "}
                                <li className="breadcrumb-item">Inquiry List</li>
                            </ol>
                        </div>
                    </div>
                    <div className="col-md-6 text-end">

                        &nbsp;&nbsp;&nbsp;
                    </div>
                    <Col className="col-12">
                        <Card>
                            {loader ? (
                                <CardBody style={{ height: "100px" }}>
                                    <Spinner
                                        color="info"
                                        style={{
                                            height: "4rem",
                                            width: "4rem",
                                            position: "absolute",
                                            left: "50%",
                                        }}
                                    >
                                        Loading...
                                    </Spinner>
                                </CardBody>
                            ) : (
                                <CardBody className="table-shorting">
                                    {
                                        <PaginationProvider
                                            pagination={paginationFactory({
                                                page: currentFPage,
                                                sizePerPage: sizePerPageOrg,
                                                totalSize: totalPage,
                                                custom: true,
                                            })}
                                        >
                                            {({ paginationProps, paginationTableProps }) => (
                                                <>
                                                    <ToolkitProvider
                                                        keyField="_id"
                                                        data={Categorydata}
                                                        columns={columns}
                                                    >
                                                        {(props) => (
                                                            <Row>
                                                                <Col className="col-lg-12 d-flex mb-3">
                                                                    <label className="mb-0 text-label">
                                                                        Page Size
                                                                    </label>

                                                                    <select
                                                                        value={sizePerPageOrg}
                                                                        onChange={handleChange}
                                                                        className="form-select"
                                                                        style={{ width: "7%" }}
                                                                    >
                                                                        <option value="10">10</option>

                                                                        <option value="20">20</option>

                                                                        <option value="50">50</option>
                                                                    </select>

                                                                    <label className="mb-0 text-label ms-3">
                                                                        Sort Order:
                                                                    </label>
                                                                    <select
                                                                        value={sortOrder}
                                                                        onChange={handlesortOrder}
                                                                        className="form-select"
                                                                        style={{ width: "10%" }}
                                                                    >
                                                                        <option value="asc"> Ascending</option>
                                                                        <option value="desc">Descending</option>
                                                                    </select>

                                                                    <label className="mb-0 text-label ms-3">
                                                                        Sort By:
                                                                    </label>
                                                                    <select
                                                                        value={sort}
                                                                        onChange={handlesorting}
                                                                        className="form-select"
                                                                        style={{ width: "10%" }}
                                                                    >
                                                                        <option value='' selected>Select Type</option>
                                                                        <option value="open">Open</option>
                                                                        <option value="closed">Close</option>
                                                                    </select>

                                                                    <div className="filter-item" style={{ width: '86.5%' }}>
                                                                        <input
                                                                            type="search"
                                                                            placeholder="Search"
                                                                            value={searchText}
                                                                            class="form-control"
                                                                            onChange={(e) =>
                                                                                setSearchText(e.target.value)
                                                                            }
                                                                            style={{ width: "30%" }}
                                                                        />
                                                                        <button
                                                                            onClick={() => {
                                                                                fetchTransactionsList();
                                                                            }}
                                                                            type="button"
                                                                            className="btn btn-primary mx-2"
                                                                        >
                                                                            Search
                                                                        </button>

                                                                        <button
                                                                            type="button"
                                                                            onClick={handleReload}
                                                                            className="btn btn-danger mx-2"
                                                                        >
                                                                            Reset
                                                                        </button>
                                                                        {/* <button
                                      type="button"
                                      onClick={toggleModel}
                                      className="btn btn-info"
                                    >
                                      Filter
                                    </button> */}
                                                                    </div>
                                                                </Col>

                                                                <Col className="col-lg-12 text-end">
                                                                    <BootstrapTable
                                                                        onTableChange={handleTableChange}
                                                                        remote={true}
                                                                        classes="table-striped"
                                                                        {...props.baseProps}
                                                                        {...paginationTableProps}
                                                                    />
                                                                </Col>
                                                            </Row>
                                                        )}
                                                    </ToolkitProvider>

                                                    <Row>
                                                        <Col className="col-lg-12 text-end">
                                                            <div className="text-md-right">
                                                                <PaginationListStandalone
                                                                    {...paginationProps}
                                                                />
                                                            </div>
                                                        </Col>
                                                    </Row>
                                                </>
                                            )}
                                        </PaginationProvider>
                                    }
                                </CardBody>
                            )}
                        </Card>
                    </Col>
                </Row>
                {openLightbox && (
                    <>
                        <Lightbox
                            mainSrc={image}
                            onCloseRequest={() => setOpenLightBox(false)}
                            toolbarButtons={[
                                <button
                                    className="btn btn-primary"
                                    key="download"
                                    onClick={handleDownload}
                                >
                                    Download
                                </button>,
                            ]}
                        />
                    </>
                )}
            </React.Fragment>

        </>
    );
};

export default InquiryList;
